import { ComponentProps } from 'react';
import {
    Item as ItemBase,
    Suggest as SuggestBase,
} from '@yandex-int/hr-components/Suggest/desktop/bundle';

export const Suggest = SuggestBase;
export type SuggestProps = ComponentProps<typeof Suggest>;
export type Item = ItemBase;
